import { ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface KPICalculation {
	parts?: KPICalculationPart[];
	goal?: number;
	isPercentage?: boolean;
	isMonthly?: boolean;
	isTime?: boolean;
	isImportant?: boolean;
	label?: string;
	description?: string;
	id?: string;
	externalDataId?: string;
	externalDataType?: string;
	dateColumn?: string;
	isDefault?: boolean;
	// added in frontend
	finalSum?: number;
	delta?: number;
	isFloat: boolean;
}

export interface KPICalculationPart {
	type?: string;
	value?: any;
	label?: string;
	entity?: string;
	id?: string;
	icon?: string;
	property?: string;
	count?: number;
	parentEntityId?: string;
	parentEntityType?: string;
}

export interface KPICalculationResult {
	evalString: string;
	valid: boolean;
	result?: number;
	haveStats?: boolean;
}

@Injectable()
export class ProjectKpiService {
	kpiSelectionSubject = new ReplaySubject<KPICalculation>(1);
	performanceStatsData: any = {};

	constructor() {

	}

	setPerformanceStatsData(kpiStats: any) {
		if (kpiStats?.id) {
			this.performanceStatsData[kpiStats.id] = kpiStats;
		}
	}

	calculateKpi(kpi: KPICalculation): KPICalculationResult {
		if (kpi?.id && this.performanceStatsData[kpi.id] && this.performanceStatsData[kpi.id].cumulative) {
			return this.performanceStatsData[kpi.id].cumulative;
		}
	}

	selectKPI(kpi: KPICalculation) {
		this.kpiSelectionSubject.next(kpi);
	}
}
